<template>
    <div class="pt-collapse-item" :class="{ 'is-active': isActive, 'is-disabled': disabled }">
        <div
            role="tab"
            :aria-expanded="isActive"
            :aria-controls="`pt-collapse-content-${id}`"
            :aria-describedby="`pt-collapse-content-${id}`"
        >
            <div
                :id="`pt-collapse-head-${id}`"
                class="pt-collapse-item__header"
                role="button"
                :tabindex="disabled ? -1 : 0"
                :class="{
                    focusing: focusing,
                    'is-active': isActive,
                }"
                @click="handleHeaderClick"
                @keyup.space.enter.stop="handleEnterClick"
                @focus="handleFocus"
                @blur="focusing = false"
            >
                <slot name="title">{{ title }}</slot>
                <pt-icon
                    icon="PTX-icon-select-12"
                    :style="{
                        width: '20px',
                        height: '20px',
                    }"
                    class="pt-collapse-item__arrow pt-icon-arrow-right"
                    :class="{ 'is-active': isActive }"
                ></pt-icon>
            </div>
        </div>
        <pt-collapse-transition>
            <div
                v-show="isActive"
                :id="`pt-collapse-content-${id}`"
                class="pt-collapse-item__wrap"
                role="tabpanel"
                :aria-hidden="!isActive"
                :aria-labelledby="`pt-collapse-head-${id}`"
            >
                <div class="pt-collapse-item__content">
                    <slot></slot>
                </div>
            </div>
        </pt-collapse-transition>
    </div>
</template>
<script lang="ts">
import { defineComponent, PropType, inject, computed, ref } from 'vue';
import { CollapseProvider } from './collapse';
import { generateId } from '../../../utils/util';
import PtCollapseTransition from '../../collapse-transition/index';

export default defineComponent({
    name: 'PtCollapseItem',
    components: { PtCollapseTransition },
    props: {
        title: {
            type: String,
            default: '',
        },
        name: {
            type: [String, Number] as PropType<string | number>,
            default: () => {
                return generateId();
            },
        },
        disabled: Boolean,
    },
    setup(props) {
        const collapse = inject<CollapseProvider>('collapse');
        const collapseMitt = collapse?.collapseMitt;

        const contentWrapStyle = ref({
            height: 'auto',
            display: 'block',
        });
        const contentHeight = ref(0);
        const focusing = ref(false);
        const isClick = ref(false);
        const id = ref(generateId());

        const isActive = computed(() => {
            return collapse?.activeNames.value.indexOf(props.name) > -1;
        });

        const handleFocus = () => {
            setTimeout(() => {
                if (!isClick.value) {
                    focusing.value = true;
                } else {
                    isClick.value = false;
                }
            }, 50);
        };

        const handleHeaderClick = () => {
            if (props.disabled) return;
            collapseMitt?.emit('item-click', props.name);
            focusing.value = false;
            isClick.value = true;
        };

        const handleEnterClick = () => {
            collapseMitt?.emit('item-click', props.name);
        };

        return {
            isActive,
            contentWrapStyle,
            contentHeight,
            focusing,
            isClick,
            id,
            handleFocus,
            handleHeaderClick,
            handleEnterClick,
            collapse,
        };
    },
});
</script>
